// extracted by mini-css-extract-plugin
module.exports = {"loader":"application-loader_loader__5p_Ss","middle":"application-loader_middle__jML2M"};